var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBuildingAction, selectBuildingActionType, selectIsGridVisible, selectSelectedBuildingInfo, selectSelectedBuildingIsPremium, } from "../../selectors/selectExistingBuildingInfo";
import { actionBuildingsCancelMove, actionBuildingsCancelPlacement, actionBuildingsCancelUnstoreBuilding, actionBuildingsDemolish, actionBuildingsFinishMove, actionBuildingsFinishPlacement, actionBuildingsFinishUnstoreBuilding, actionBuildingsMoveMove, actionBuildingsMovePlacement, actionBuildingsMoveUnstore, actionBuildingsRotateMove, actionBuildingsRotatePlacement, actionBuildingsRotateUnstore, actionBuildingsStoreBuilding, } from "../player-base/buildings/actionBuildings";
import { PlacementModeButtons } from "./PlacementModeButtons";
var PlacementModeContainerDOM = /** @class */ (function (_super) {
    __extends(PlacementModeContainerDOM, _super);
    function PlacementModeContainerDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlacementModeContainerDOM.prototype.render = function () {
        var isGridVisible = this.props.isGridVisible;
        return isGridVisible && React.createElement(PlacementModeButtons, __assign({}, this.props));
    };
    return PlacementModeContainerDOM;
}(React.Component));
var mapState = function (state) { return ({
    building: selectSelectedBuildingInfo(state),
    buildingAction: selectBuildingAction(state),
    buildingActionType: selectBuildingActionType(state),
    isGridVisible: selectIsGridVisible(state),
    premium: selectSelectedBuildingIsPremium(state),
}); };
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onCancelMove: actionBuildingsCancelMove,
        onCancelPlacement: actionBuildingsCancelPlacement,
        onCancelUnstore: actionBuildingsCancelUnstoreBuilding,
        onDemolish: actionBuildingsDemolish,
        onFinishMove: actionBuildingsFinishMove,
        onFinishPlace: actionBuildingsFinishPlacement,
        onFinishUnstore: actionBuildingsFinishUnstoreBuilding,
        onRotateMove: actionBuildingsRotateMove,
        onRotatePlacement: actionBuildingsRotatePlacement,
        onRotateUnstore: actionBuildingsRotateUnstore,
        onStartMove: actionBuildingsMoveMove,
        onStartPlacement: actionBuildingsMovePlacement,
        onStartUnstore: actionBuildingsMoveUnstore,
        onStore: actionBuildingsStoreBuilding,
    }, dispatch);
};
export var PlacementModeContainer = connect(mapState, mapDispatch)(PlacementModeContainerDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/navigation/PlacementModeContainer.tsx
// module id = 2271
// module chunks = 3